import { render, staticRenderFns } from "./ProjetDetail.vue?vue&type=template&id=9ae9b4e2&scoped=true&"
import script from "./ProjetDetail.vue?vue&type=script&lang=js&"
export * from "./ProjetDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProjetDetail.vue?vue&type=style&index=0&id=9ae9b4e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae9b4e2",
  null
  
)

export default component.exports